import { render, staticRenderFns } from "./RemoveIntegrationModal.vue?vue&type=template&id=41095e30&"
import script from "./RemoveIntegrationModal.vue?vue&type=script&lang=ts&"
export * from "./RemoveIntegrationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports